import { type SupportedCountries, SupportedCurrencies } from '@wanda-space/types'

export const CURRENCIES_BY_COUNTRY: Record<SupportedCountries, SupportedCurrencies> = {
  NO: SupportedCurrencies.NOK,
  SE: SupportedCurrencies.SEK,
}
